import { Component, Inject, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { ProfileService } from "../../profile.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-otp-model",
  templateUrl: "./otp-model.component.html",
})
export class OtpModelComponent implements OnInit {
  btnDisable: boolean = false;
  model: any = {};
  isLoading = false;
  fieldStatus = false;

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public profileService: ProfileService,
    public dialogRef: MatDialogRef<OtpModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.fieldStatus = true;
    }, 200);
  }

  onSubmit() {
    this.model.token = this.data.OTP_token;
    if (this.btnDisable) {
      this.spinner.show();
      this.btnDisable = false;
      this.isLoading = true;
      this.profileService.updateMobileNumber(this.model).subscribe(
        (res) => {
          if (res) {
            this.spinner.hide();
            this.isLoading = false;
            this.toastr.success(res.message, "Success!", {
              closeButton: true,
            });
            this.dialogRef.close(res);
          }
        },
        (err) => {
          this.btnDisable = true;
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        }
      );
    }
  }

  onOtpChange(event) {
    this.btnDisable = false;
    if (event.length == 4) {
      this.btnDisable = true;
      this.model.oTP = event;
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
